export const defaultCurrencyCode = "RON"
